export const defaultCurrencyCode = "RON"
